"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CROWLINK_AUTOMATION_STATUS_LABELS = exports.CrowLinkAutomationStatuses = void 0;
exports.isStorefrontNewerThanCrowLink = isStorefrontNewerThanCrowLink;
exports.resolveCrowLinkAutomationStatus = resolveCrowLinkAutomationStatus;
exports.CrowLinkAutomationStatuses = [
    'AWAITING_TRAFFIC',
    'QUEUED',
    'LAUNCHED',
];
exports.CROWLINK_AUTOMATION_STATUS_LABELS = {
    AWAITING_TRAFFIC: 'Awaiting Traffic',
    QUEUED: 'Queued for AI Generation',
    LAUNCHED: 'Generated & Launched',
};
function isStorefrontNewerThanCrowLink(storefrontCreatedAt, crowLinkCreatedAt) {
    if (!storefrontCreatedAt || !crowLinkCreatedAt) {
        return false;
    }
    return (new Date(storefrontCreatedAt).getTime() >
        new Date(crowLinkCreatedAt).getTime());
}
function resolveCrowLinkAutomationStatus(input) {
    // Only bulk create sets automation settings; other crowlinks are not in
    // the automation pipeline and have no status.
    if (!input.hasAutomationSettings) {
        return null;
    }
    if (input.isPointingToNewStorefront) {
        return 'LAUNCHED';
    }
    if (input.hasTraffic) {
        return 'QUEUED';
    }
    return 'AWAITING_TRAFFIC';
}
